import ReactDOM from 'react-dom';

const ActionResultsPortal: React.FC<React.PropsWithChildren> = ({ children }) => {
  const adyenResultContainer = document.querySelector('.adyen-checkout__qr-loader');

  if (!adyenResultContainer) {
    return null;
  }

  return (
    <>
      {ReactDOM.createPortal(
        <div className="custom-qr-code-results">{children}</div>,
        adyenResultContainer,
      )}
    </>
  );
};

export default ActionResultsPortal;
